import React, { useRef, useState, useEffect } from "react";
import ReactDOM from "react-dom";
import { Line } from "react-chartjs-2";
import { Chart, registerables } from 'chart.js';
import ChartJS from 'chart.js/auto';
import annotationPlugin  from 'chartjs-plugin-annotation';
import LinearScaleIcon from "@material-ui/icons/LinearScale";
import ChartDataLabels from 'chartjs-plugin-datalabels';
import 'chartjs-adapter-date-fns';
//import { enUS } from 'date-fns/locale';
Chart.register(annotationPlugin);
const data = [110, 120, 105, 181, 190, 151, 140, 100, 250, 300];
const PURPLE = "#FFFF00";
const GREEN = "#85FB52";
const GREEN_LIGHT = "#57C592";
const RED = "#FF0000";
const BLUE = "#FFFF00";
const WHITE = "#fff";

function Animatedchart(){
    const chartRef = useRef(null);
  const [legend, setLegend] = useState([]);

  const dataBar = {
   // plugins: [ChartDataLabels],
    labels: [
      "Fasting",
      "Pre Breakfast",
      "Post Breakfast",
      "Pre Lunch",
      "Post Lunch",
      "Post Dinner",
      "Bad Time",
      "Post Breakfast",
      "Pre Lunch",
      "Post Lunch",
      "Post Dinner",
      "Fasting"
    ],
    datasets: [
      {
        //label: "Readings",
        type: "line",
        data: [70, 120, 105, 181, 190, 151, 140, 100, 180, 300, 140, 59],
        fill: false,
        lineTension: 0,
        pointBorderColor: 'transparent',
        backgroundColor: '#0987ded9',
        borderColor: '#0987ded9',
        hoverBackgroundColor: '#0987ded9',
        hoverBorderColor: '#0987ded9',
        order: 1
      }
    ]
  };

//   const options = {
//     legend: {
//       position: "bottom",
//       display: false
//     },
//     title: {
//       display: true,
//       text: "Readings",
//       position: "bottom",
//       fontSize: 25
//     },

//     responsive: true,
//     tooltips: {
//       mode: "label"
//     },
//     elements: {
//       line: {
//         fill: false
//       }
//     },
//     scales: {
//         x: {
//          //   type: 'time',
//             stacked: true,
//             display: true,
//             // time: {
//             //   minUnit: 'month'
//             // }
//           },
//           y:  {
//           stacked: true,
//           type: "linear",
//           display: true,
//           //position: "right",
//           gridLines: {
//             display: true
//           },
//           labels: {
//             show: true
//           }
//           // scaleLabel: {
//           //   display: true,
//           //   labelString: "Profit USD",
//           //   fontSize: 25,
//           //   fontColor: GREEN_LIGHT
//           // }
//         },
//         //   xAxes: [
//     //     {
//     //       stacked: true,
//     //       display: true,

//     //       gridLines: {
//     //         display: false
//     //       }
//     //     }
//     //   ],
//     //   yAxes: [
//     //     {
//         //   stacked: true,
//         //   type: "linear",
//         //   display: true,
//         //   //position: "right",
//         //   gridLines: {
//         //     display: true
//         //   },
//         //   labels: {
//         //     show: true
//         //   }
//         //   // scaleLabel: {
//         //   //   display: true,
//         //   //   labelString: "Profit USD",
//         //   //   fontSize: 25,
//         //   //   fontColor: GREEN_LIGHT
//         //   // }
//         // }
//     //     // {
//     //     //   //display: true,
//     //     //   position: "left",
//     //     //   // gridLines: {
//     //     //   //   display: false,
//     //     //   //   color: RED
//     //     //   // },
//     //     //   labels: {
//     //     //     display: false,
//     //     //     show: false
//     //     //   },
//     //     //   // scaleLabel: {
//     //     //   //   display: true,
//     //     //   //   labelString: "Units Sold",
//     //     //   //   fontSize: 25,
//     //     //   //   fontColor: PURPLE
//     //     //   // },
//     //     //   ticks: {
//     //     //     fontColor: WHITE
//     //     //   }
//     //     // }
//     //   ]
//     },
//     annotation: {
//       annotations: [
//         {
//           type: "line",
//           mode: "horizontal",
//           scaleID: "y-axis-0",
//           value: 180,
//           borderColor: GREEN,
//           borderWidth: 2,
//           label: {
//             backgroundColor: RED,
//             //content: "Test Label",
//             enabled: true
//           }
//         },
//         {
//           type: "line",
//           mode: "horizontal",
//           scaleID: "y-axis-0",
//           value: 180,
//           borderColor: RED,
//           borderWidth: 2,
//           label: {
//             backgroundColor: RED,
//             //content: "Test Label",
//             enabled: true
//           }
//         },
//         {
//           type: "line",
//           mode: "horizontal",
//           scaleID: "y-axis-0",
//           value: 80,
//           borderColor: PURPLE,
//           borderWidth: 1,
//           label: {
//             backgroundColor: RED,
//             //content: "Test Label",
//             enabled: true
//           }
//         },
//         {
//           type: "line",
//           mode: "horizontal",
//           scaleID: "y-axis-0",
//           value: 120,
//           borderColor: GREEN,
//           borderWidth: 2,
//           label: {
//             backgroundColor: RED,
//             //content: "Test Label",
//             enabled: true
//           }
//         }
//       ]
//     }
//   };
const options = {
  plugins: {
      autocolors: false,
      responsive: true,
      annotation: {
          annotations: {
              line1: {
                  type: 'line',
                  yMin: 70,
                  yMax: 70,
                  borderColor: '#FFCC00',
                  borderWidth: 2,
              },
              line2: {
                  type: 'line',
                  yMin: 120,
                  yMax: 120,
                  borderColor: 'green',
                  borderWidth: 2,
              },
              line3: {
                  type: 'line',
                  content: 'line',
                  yMin: 180,
                  yMax: 180,
                  borderColor: 'rgb(255, 99, 132)',
                  borderWidth: 2,
              },
             
              
          }
      }
  }
};
// const options = {
//     plugins: {
//       autocolors: false,
//       maintainAspectRatio: true,
//       plugins: {
//         datalabels: {
//             anchor: 'end',
//             align: 'top',
//             formatter: Math.round,
//             font: {
//                 weight: 'bold'
//             }
//         }
//     },
//       annotation: {
//         annotations: {
//           // line1: {
//           //   type: 'line',
//           //   yMin: 80,
//           //   yMax: 80,
//           //   borderColor: '#ffff00ab',
//           //   borderWidth: 28,
//           // },
//           line2: {
//             type: 'line',
//             yMin: 150,
//             yMax: 150,
//             borderColor: 'rgba(153,255,51,0.4)',
//             backgroundColor: "rgba(153,255,51,0.4)",
//             borderWidth: 130,
//           },
//           // line3: {
//           //   type: 'line',
//           //   yMin: 500,
//           //   yMax: 500,
//           //   borderColor: '#e01313ad',
//           //   borderWidth: 500,
//           // },
//           // line4: {
//           //   type: 'line',
//           //   yMin: 500,
//           //   yMax: 500,
//           //   borderColor: 'rgb(255, 99, 132)',
//           //   borderWidth: 2,
//           // }
//         }
//       }
//     }
//   };
  const listItemStyle = {
    color: "#333",
    listStyle: "none",
    textAlign: "left",
    display: "flex",
    flexDirection: "row",
    margin: "8px",
    justifyContent: "center",
    alignItems: "center"
  };

  

  return (
    <div
      title={"title"}
      isLoading={false}
      style={{
        whiteSpace: "pre",
        display: "flex",
        flexDirection: "column",
        backgroundColor: WHITE,
        width:'100%',margin:10
      }}
    >
      <Line
        // getDatasetAtEvent={(dataset) => console.log("dataset", dataset)}
        // onElementsClick={(e) => {
        //   console.log("e", e);
        //   console.log("c", c);
        // }}
        //ref={chartRef}
        data={dataBar}
        options={options}
      />

      
    </div>
  );
}


export default Animatedchart;                           
